export default __webpack_public_path__ + "static/charm-116f833e5c014bf3962ba21af6e47801.png";